import PenIcon from "@/assets/pen.png";
import { formatGoalDescription } from "@/utils/generalUtilities";
import { SummaryGoal } from "@/types/summary";

interface GoalsSectionProps {
  data: SummaryGoal[];
  onEdit: () => void;
}

const GoalsSection = ({ data, onEdit }: GoalsSectionProps) => {
  const formatCurrency = (amount: number | undefined) => {
    if (!amount) return "$0";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const extractYear = (dateString: string | undefined) => {
    if (!dateString) return "";
    const year = dateString.match(/\d{4}/);
    return year ? year[0] : dateString;
  };

  const getGoalDisplayText = (purpose: string | undefined) => {
    if (!purpose) return "";
    const description = formatGoalDescription(purpose);
    if (description === "Saving for college or university") {
      return "a college";
    }
    if (description === "Saving for trade school") {
      return "trade school";
    }
    return description;
  };

  return (
    <div className="border-b-[1px] border-[#E2E2E2] p-[20px]">
      <div className="flex justify-between items-center mb-[16px]">
        <h3 className="text-[1.125rem]">Goals</h3>
        <button
          onClick={onEdit}
          className="text-[#00ADAC] hover:text-[#008281] text-[1.125rem] cursor-pointer border-none bg-transparent flex items-center gap-1"
        >
          <img src={PenIcon} className="w-[18px] h-[18px]" alt="Edit" />
          Edit
        </button>
      </div>

      <div className="space-y-[12px]">
        {data.map((goal) => (
          <div key={goal.minorAccountID}>
            <div className="flex justify-between items-start">
              <div>
                <p className="text-[16px]">
                  {goal.fullName || `Beneficiary ${goal.minorAccountID}`}
                </p>
                <p className="text-[1rem] text-[#8B8B8B]">
                  Starting {getGoalDisplayText(goal.purpose)} in{" "}
                  {extractYear(goal.timeline)}
                </p>
                <p className="text-[1rem] text-[#8B8B8B]">
                  {formatCurrency(goal.amount)}
                </p>
              </div>
            </div>
          </div>
        ))}

        {data.length === 0 && (
          <div className="text-center text-[#8B8B8B]">
            <p>No goals set yet.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GoalsSection;
